<template>
    <div :class="styleClass || ''">
        <div class="input-group date" :id="elementId" data-target-input="nearest">
            <!-- TODO how to improve style? -->
            <input type="text"
                   :disabled="disabled ? disabled : false"
                   autocomplete="off"
                   :id="`${elementId}-input`"
                   class="form-control"
                   :class="inputClass || 'datetimepicker-input'"
                   :data-target="`#${elementId}`"
                   @click.prevent="toggleTimepicker" />
            <div class="input-group-append" :class="disabled ? 'datetimepicker-input-append-disabled' : ''" :data-target="`#${elementId}`" data-toggle="datetimepicker" style="flex: 0;">
                <div class="input-group-text"><i class="far fa-clock" :class="disabled ? 'icon-disabled' : ''"></i></div>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapActions} from 'vuex';
    import momentTz from 'moment-timezone';

    import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css';

    export default {
        name: 'timepicker',

        props: ['id', 'selected', 'disabled', 'styleClass', 'inputClass', 'minuteInterval'],

        data() {
            return {
                // ID is used for data-target, fallback to random string
                elementId: this.id || Math.random().toString(36).substring(2, 15)
            };
        },

        mounted() {
            this.mount();
        },

        methods: {

            ...mapActions(['swalToast']),

            mount() {
                this.$nextTick(() => {
                    let time;

                    if (this.selected) {
                        time = {
                            hour: this.selected.HH,
                            minute: this.selected.mm
                        };
                    }

                    const timePicker = $(`#${this.elementId}`);

                    timePicker.datetimepicker({
                        locale: moment.locale(),
                        defaultDate: momentTz(time),
                        format: 'HH:mm',
                        stepping: this.minuteInterval || 5,
                        // Keep invalid for now to avoid tempusdominus errors
                        keepInvalid: true,
                        tooltips: {
                            today: this.trans('plugins.datetimepicker.today'),
                            clear: this.trans('plugins.datetimepicker.clear'),
                            close: this.trans('plugins.datetimepicker.close'),
                            selectMonth: this.trans('plugins.datetimepicker.select_month'),
                            prevMonth: this.trans('plugins.datetimepicker.previous_month'),
                            nextMonth: this.trans('plugins.datetimepicker.next_month'),
                            selectYear: this.trans('plugins.datetimepicker.select_year'),
                            prevYear: this.trans('plugins.datetimepicker.previous_year'),
                            nextYear: this.trans('plugins.datetimepicker.next_year'),
                            selectDecade: this.trans('plugins.datetimepicker.select_decade'),
                            prevDecade: this.trans('plugins.datetimepicker.previous_decade'),
                            nextDecade: this.trans('plugins.datetimepicker.next_decade'),
                            prevCentury: this.trans('plugins.datetimepicker.previous_century'),
                            nextCentury: this.trans('plugins.datetimepicker.next_century'),
                            incrementHour: this.trans('plugins.datetimepicker.increment_hour'),
                            pickHour: this.trans('plugins.datetimepicker.pick_hour'),
                            decrementHour: this.trans('plugins.datetimepicker.decrement_hour'),
                            incrementMinute: this.trans('plugins.datetimepicker.increment_minute'),
                            pickMinute: this.trans('plugins.datetimepicker.pick_minute'),
                            decrementMinute: this.trans('plugins.datetimepicker.decrement_minute'),
                            incrementSecond: this.trans('plugins.datetimepicker.increment_second'),
                            pickSecond: this.trans('plugins.datetimepicker.pick_second'),
                            decrementSecond: this.trans('plugins.datetimepicker.decrement_second')
                        }
                    });

                    const self = this;

                    timePicker.on('change.datetimepicker datetimepicker.change', function () {
                        // Emit on change if picker is not open
                        if (!$(self.$el).find('.bootstrap-datetimepicker-widget').length) {
                            self.emitChanges();
                        }
                    });

                    timePicker.on('hide.datetimepicker datetimepicker.hide', function () {
                        // Emit on closing picker
                        self.emitChanges();
                    });

                    timePicker.on('error.datetimepicker datetimepicker.error', function () {
                        self.swalToast({type: 'error', message: self.trans('exceptions.invalid_time_input')});
                    });
                });
            },

            emitChanges() {
                const moment = $(`#${this.elementId}`).datetimepicker('viewDate');
                const hour = moment.format('HH');
                const minute = moment.format('mm');

                if (hour !== this.selected.HH || minute !== this.selected.mm) {
                    this.$emit('update', {
                        HH: hour,
                        mm: minute
                    });
                }
            },

            toggleTimepicker() {
                $(`#${this.elementId}`).datetimepicker('toggle');
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/DateTimepicker/Timepicker.vue